import { I18n } from 'i18n-js';
import de from './translations/de.js';
import en from './translations/en.js';
import es from './translations/es.js';
import nl from './translations/nl.js';

const translations = {
  de,
  en,
  es,
  nl
};

const i18n = new I18n();
i18n.defaultLocale = 'en';
i18n.translations = translations;

let terminology = {};

// Business-type terminology (member/class/course wording per organisation type) is
// injected by the server on the body tag. Placeholders the caller does not
// provide resolve to the current business type's term; unknown placeholders stay
// literal, mirroring the server-side substitution.
i18n.missingPlaceholder = (_i18nInstance, placeholder) => {
  const termName = placeholder.replace(/^%\{/, '').replace(/\}$/, '');

  return terminology[termName] ?? placeholder;
};

// Turbolinks replaces the <body> on navigation but keeps this module (and the
// <html lang> attribute) alive, so the locale must be re-read from the fresh
// body on every visit. Falls back to <html lang> for full page loads.
export const syncLocale = () => {
  const locale = document.body?.dataset?.locale || document.documentElement.lang;
  const terminologyData = document.body?.dataset?.terminology;

  terminology = terminologyData ? JSON.parse(terminologyData) : {};

  if (translations[locale]) {
    i18n.locale = locale;
  } else {
    console.error(`No translations found for locale ${locale}`);
  }
};

syncLocale();
document.addEventListener('turbolinks:load', syncLocale);

export default i18n;
